import { publicSiteConfig } from '../public/publicSiteConfig';

export const plannerDashboardConfig = {
  applicationName: 'Tov+ Planner Dashboard',
  supportEmail: 'hello@tovplus.com',
  docsUrl: publicSiteConfig.docsSiteUrl,
  marketingUrl: publicSiteConfig.marketingSiteUrl,
  plannerSignInUrl: publicSiteConfig.routes.signIn,
  plannerSignUpUrl: publicSiteConfig.routes.signUp,
} as const;
